import { ApplicationListMakati } from "./components/ApplicationListMakati"
import { ApplicationListSTD } from "./components/ApplicationListSTD"
import { ApplicationListCDLI } from "./components/ApplicationListCDLI";

export function ApplicationList() {

   var subdomain = localStorage.getItem("lms-subdomain");

   const applicationList = () => {
      const components = {
         'dbti-makati': ApplicationListMakati,
         'localhost': ApplicationListMakati,
         'dbtishs-edu': ApplicationListMakati,
         'casadellibroinc': ApplicationListCDLI
      };

      const Component = components[subdomain] || ApplicationListSTD;
      return <Component />;
   };

   return (
      <>
         {
            applicationList()
         }
      </>
   )
}
